/**
 * This component is responsible for displaying the game recap for a specific game, made up of GameEvent components.
 */
import React from "react";
import GameEvent from "./GameEvent";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import Loading from "../core/Loading";

const processRecapData = (jsonData) => {
  return jsonData;
};

const GameRecap = (game_data) => {
  const { gameId } = useParams();

  const { isLoading, error, data } = useQuery({
    staleTime: 3600000,
    queryKey: ["game", gameId, "recap"],
    queryFn: () =>
      fetch(`${process.env.REACT_APP_BUIHA_API_URL}/game/${gameId}/recap/`)
        .then((res) => res.json())
        .then((json) => {
          return processRecapData(json);
        }),
  });

  if (isLoading)
    return (
      <Loading />
    );
    

  if (error) return "An error has occurred: " + error.message;

  return (
    // Container for all pages
    <>
      {/*h1 className="text-left text-2xl font-bold mb-2">Game Recap</h1>*/}

      {Object.keys(data.events).map(function (period) {
        return (
          <>
            <GameEvent eventName={period} title={true} />
            {data.events[period].map(function (event) {
              return (
                <GameEvent
                  eventName={event.event}
                  time={event.time}
                  eventText={event.description}
                  clubImg={event.timg}
                  player={event.pid}
                  club={event.cid}
                  profile={event.profile}
                />
              );
            })}
          </>
        );
      })}
      {/*<GameEvent eventName={"Starting Goaltender for " + data2.home_team.name} time={"00:00"} eventText={"#32 Example Person"} clubImg={data2.home_team.logo.lg} playerImg={2} />*/}
      {/*<GameEvent eventName={"Starting Goaltender for " + data2.away_team.name} time={"00:00"} eventText={"#1 The Example"} clubImg={data2.away_team.logo.lg} playerImg={6550} />*/}
    </>
  );
};
export default GameRecap;
